




























































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import * as config from './config';
import Banner from '@/components/Banner.vue';
import NewsLists from '@/components/NewsList.vue';
import BottomTabbar from '@/components/BottomTabbar.vue';
import { getBaseinfo } from '@/api/api';
import { Country, Province, NewsList, Area, CountryList } from './api';
import { Tab, Tabs, Icon, Popup } from 'vant';
import { isWeiXin, autoOpenApp } from '@/common/ts/common';
import Title from './Title.vue';
import { drawChart, ChongQChart, lineChart } from './mapConfig';
import echarts from 'echarts';
import 'echarts/map/js/china';
import 'echarts/map/js/china-contour';
import 'echarts/map/js/province/chongqing';

Vue.prototype.$echarts = echarts;
Vue.use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Popup);
@Component({
  components: {
    Banner,
    Title,
    NewsLists,
  },
})
export default class Home extends Vue {
  @Prop({ default: true }) shareVal!: boolean;
  option = config.OPTHINES;
  baseInfo = {};
  pointOut: boolean = false;
  CountryData = {};
  ProvinceData = [];
  AreaData = [];
  NewsListData = [];
  Yesterday = {};
  YesterdayCQ = {};
  active = 0;
  BigActive = 0;
  show = false;
  async created() {
    const res = await getBaseinfo(this.option.voteName);
    this.baseInfo = res.data;
    // 顶部病例信息
    this.getCountry();
    // 全国地图数据
    this.getProvince();
    // 重庆地图数据
    this.getArea();
    // 新闻列表
    this.getNewsList();
    // 折线图数据
    this.getCountryList();
    // 分享
    this.shareInfo();
    // 统计
    this.$addPv(2130185, 1);
    this.$addPv(2130232, 3608);
  }
  // 设置分享
  shareInfo() {
    if (this.shareVal) {
      this.$appShareInfo({
        title: '新型冠状病毒感染的肺炎疫情实时追踪',
        url: window.location.href,
        subtitle: '疫情实时追踪',
        classId: -1,
        id: -1,
        image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
        type: 3,
      });
      this.$wxShareInfo({
        title: '新型冠状病毒感染的肺炎疫情实时追踪',
        subtitle: '疫情实时追踪',
        image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      });
    }
  }
  async getCountry() {
    const res = await Country(this.option.voteName);
    this.CountryData = res.data;
  }
  async getProvince() {
    const res = await Province(this.option.voteName);
    this.ProvinceData = res.data;
    drawChart(res.data);
  }
  async getArea() {
    const res = await Area(this.option.voteName);
    this.AreaData = res.data;
    // ChongQChart(res.data);
  }
  async getNewsList() {
    const res = await NewsList(this.option.voteName);
    this.NewsListData = res.data;
  }
  async getCountryList() {
    const res = await CountryList(this.option.voteName);
    lineChart(res.data);
    if (res.data) {
      const needData = res.data.country.addData;
      const needDataCQ = res.data.chongqing.addData;
      this.Yesterday = {
        ascertain: needData.ascertain[needData.ascertain.length - 1],
        cure: needData.cure[needData.cure.length - 1],
        death: needData.death[needData.death.length - 1],
        suspected: needData.suspected[needData.suspected.length - 1],
      };
      this.YesterdayCQ = {
        ascertain: needDataCQ.ascertain[needDataCQ.ascertain.length - 1],
        cure: needDataCQ.cure[needDataCQ.cure.length - 1],
        death: needDataCQ.death[needDataCQ.death.length - 1],
      };
    }
  }
  qsShow() {
    this.show = true;
  }
  closeShow() {
    this.show = false;
  }
}
